export const DailyCategoryColumns = [
  // Attributes
  {
    id: "1",
    title: "Group Name",
    key: "group_name",
    visible: true,
    category: "Attributes",
    compare: false,
    type: "boolean",
  },

  // Clicks
  {
    id: "2",
    title: "Clicks",
    key: "current_clicks",
    visible: true,
    category: "Performance",
    compare: false,
    type: "number",
  },
  {
    id: "3",
    title: "Clicks (Previous)",
    key: "previous_clicks",
    visible: false,
    category: "Performance",
    compare: false,
    type: "number",
  },
  {
    id: "4",
    title: "Clicks % Δ",
    key: "percentage_difference_clicks",
    visible: true,
    category: "Performance",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_clicks",
      denominator: "previous_clicks",
      multiplier: 100,
    },
  },

  // Impressions
  {
    id: "5",
    title: "Impr.",
    key: "current_impressions",
    visible: true,
    category: "Performance",
    compare: false,
    type: "number",
  },
  {
    id: "6",
    title: "Impr. (Previous)",
    key: "previous_impressions",
    visible: false,
    category: "Performance",
    compare: false,
    type: "number",
  },
  {
    id: "7",
    title: "Impr. % Δ",
    key: "percentage_difference_impressions",
    visible: true,
    category: "Performance",
    compare: true,
    type: "float",
    compare_col_type: "change_percentage",
    calculation: {
      numerator: "current_impressions",
      denominator: "previous_impressions",
      multiplier: 100,
    },
  },

  // Cost
  {
    id: "8",
    title: "Cost",
    key: "current_cost",
    visible: true,
    category: "Performance",
    compare: false,
    type: "currency",
  },
  {
    id: "9",
    title: "Cost (Previous)",
    key: "previous_cost",
    visible: false,
    category: "Performance",
    compare: false,
    type: "currency",
  },
  {
    id: "10",
    title: "Cost % Δ",
    key: "percentage_difference_cost",
    visible: true,
    category: "Performance",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_cost",
      denominator: "previous_cost",
      multiplier: 100,
    },
  },

  // CTR
  {
    id: "11",
    title: "CTR",
    key: "current_ctr",
    visible: true,
    category: "Performance",
    compare: false,
    type: "float",
    calculation: {
      numerator: "current_clicks",
      denominator: "current_impressions",
      multiplier: 100,
    },
  },
  {
    id: "12",
    title: "CTR (Previous)",
    key: "previous_ctr",
    visible: false,
    category: "Performance",
    compare: false,
    type: "float",
    calculation: {
      numerator: "previous_clicks",
      denominator: "previous_impressions",
      multiplier: 100,
    },
  },
  {
    id: "13",
    title: "CTR % Δ",
    key: "percentage_difference_ctr",
    visible: true,
    category: "Performance",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_ctr",
      denominator: "previous_ctr",
      multiplier: 100,
    },
  },

  // Avg. CPC
  {
    id: "14",
    title: "Avg. CPC",
    key: "current_average_cpc",
    visible: false,
    category: "Performance",
    compare: false,
    type: "currency",
    calculation: {
      numerator: "current_cost",
      denominator: "current_clicks",
    },
  },
  {
    id: "15",
    title: "Avg. CPC (Previous)",
    key: "previous_average_cpc",
    visible: false,
    category: "Performance",
    compare: false,
    type: "currency",
    calculation: {
      numerator: "previous_cost",
      denominator: "previous_clicks",
    },
  },
  {
    id: "16",
    title: "Avg. CPC % Δ",
    key: "percentage_difference_average_cpc",
    visible: false,
    category: "Performance",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_average_cpc",
      denominator: "previous_average_cpc",
      multiplier: 100,
    },
  },

  // Avg. CPM
  {
    id: "141",
    title: "Avg. CPM",
    key: "current_average_cpm",
    visible: false,
    category: "Performance",
    compare: false,
    type: "currency",
    calculation: {
      numerator: "current_cost",
      denominator: "current_impressions",
      multiplier: 1000,
    },
  },
  {
    id: "151",
    title: "Avg. CPM (Previous)",
    key: "previous_average_cpm",
    visible: false,
    category: "Performance",
    compare: false,
    type: "currency",
    calculation: {
      numerator: "previous_cost",
      denominator: "previous_impressions",
      multiplier: 1000,
    },
  },
  {
    id: "161",
    title: "Avg. CPM % Δ",
    key: "percentage_difference_average_cpm",
    visible: false,
    category: "Performance",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_average_cpm",
      denominator: "previous_average_cpm",
      multiplier: 100,
    },
  },

  // Avg. COST (Assuming this is a duplicate of Avg. CPC with a different key)
  {
    id: "142",
    title: "Avg. CPC",
    key: "current_average_cost",
    visible: false,
    category: "Performance",
    compare: false,
    type: "currency",
    calculation: {
      numerator: "current_cost",
      denominator: "current_clicks",
    },
  },
  {
    id: "152",
    title: "Avg. CPC (Previous)",
    key: "previous_average_cost",
    visible: false,
    category: "Performance",
    compare: false,
    type: "currency",
    calculation: {
      numerator: "previous_cost",
      denominator: "previous_clicks",
    },
  },
  {
    id: "162",
    title: "Avg. CPC % Δ",
    key: "percentage_difference_average_cost",
    visible: false,
    category: "Performance",
    compare_col_type: "change_percentage",
    compare: true,
    type: "float",
    calculation: {
      numerator: "current_average_cost",
      denominator: "previous_average_cost",
      multiplier: 100,
    },
  },

  // Interactions
  {
    id: "17",
    title: "Interactions",
    key: "current_interactions",
    visible: false,
    category: "Performance",
    compare: false,
    type: "number",
  },
  {
    id: "18",
    title: "Interactions (Previous)",
    key: "previous_interactions",
    visible: false,
    category: "Performance",
    compare: false,
    type: "number",
  },
  {
    id: "19",
    title: "Interactions % Δ",
    key: "percentage_difference_interactions",
    visible: false,
    category: "Performance",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_interactions",
      denominator: "previous_interactions",
      multiplier: 100,
    },
  },

  // Interaction Rate
  {
    id: "20",
    title: "Interaction Rate",
    key: "current_interaction_rate",
    visible: false,
    category: "Performance",
    compare: false,
    type: "float",
    calculation: {
      numerator: "current_interactions",
      denominator: "current_impressions",
      multiplier: 100,
    },
  },
  {
    id: "21",
    title: "Interaction Rate (Previous)",
    key: "previous_interaction_rate",
    visible: false,
    category: "Performance",
    compare: false,
    type: "float",
    calculation: {
      numerator: "previous_interactions",
      denominator: "previous_impressions",
      multiplier: 100,
    },
  },
  {
    id: "22",
    title: "Interaction Rate % Δ",
    key: "percentage_difference_interaction_rate",
    visible: false,
    category: "Performance",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_interaction_rate",
      denominator: "previous_interaction_rate",
      multiplier: 100,
    },
  },

  // Conversions
  {
    id: "23",
    title: "Conversions",
    key: "current_conversions",
    visible: false,
    category: "Conversions",
    compare: false,
    type: "number",
  },
  {
    id: "24",
    title: "Conversions (Previous)",
    key: "previous_conversions",
    visible: false,
    category: "Conversions",
    compare: false,
    type: "number",
  },
  {
    id: "25",
    title: "Conversions % Δ",
    key: "percentage_difference_conversions",
    visible: false,
    category: "Conversions",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_conversions",
      denominator: "previous_conversions",
      multiplier: 100,
    },
  },

  // Conv. Rate
  {
    id: "26",
    title: "Conv. Rate",
    key: "current_conversion_rate",
    visible: false,
    category: "Conversions",
    compare: false,
    type: "float",
    calculation: {
      numerator: "current_conversions",
      denominator: "current_clicks",
      multiplier: 100,
    },
  },
  {
    id: "27",
    title: "Conv. Rate (Previous)",
    key: "previous_conversion_rate",
    visible: false,
    category: "Conversions",
    compare: false,
    type: "float",
    calculation: {
      numerator: "previous_conversions",
      denominator: "previous_clicks",
      multiplier: 100,
    },
  },
  {
    id: "28",
    title: "Conv. Rate % Δ",
    key: "percentage_difference_conversion_rate",
    visible: false,
    category: "Conversions",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_conversion_rate",
      denominator: "previous_conversion_rate",
      multiplier: 100,
    },
  },

  // Cost / Conv.
  {
    id: "29",
    title: "Cost / Conv.",
    key: "current_cost_per_conversion",
    visible: false,
    category: "Conversions",
    compare: false,
    type: "currency",
    calculation: {
      numerator: "current_cost",
      denominator: "current_conversions",
    },
  },
  {
    id: "30",
    title: "Cost / Conv. (Previous)",
    key: "previous_cost_per_conversion",
    visible: false,
    category: "Conversions",
    compare: false,
    type: "currency",
    calculation: {
      numerator: "previous_cost",
      denominator: "previous_conversions",
    },
  },
  {
    id: "31",
    title: "Cost / Conv. % Δ",
    key: "percentage_difference_cost_per_conversion",
    visible: false,
    category: "Conversions",
    compare: true,
    compare_col_type: "change_percentage",
    type: "float",
    calculation: {
      numerator: "current_cost_per_conversion",
      denominator: "previous_cost_per_conversion",
      multiplier: 100,
    },
  },
];
